import { useState } from "react";

export default function Player({
  IntialName,
  PlayerSymbol,
  isActive,
  onNameChange,
}) {
  const [isEdit, setIsEdit] = useState(true);
  const [PlayerName, setPlayerName] = useState(IntialName);
  function handleOnEditClick() {
    setIsEdit((edit) => !edit);
    if (!isEdit) {
      onNameChange(PlayerSymbol, PlayerName);
    }
  }

  function handleChange(event) {
    setPlayerName(event.target.value);
  }

  let PlayerValue = isEdit ? (
    <span className="player-name">{PlayerName}</span>
  ) : (
    <input type="text" required value={PlayerName} onChange={handleChange} />
  );

  return (
    <>
      <li className={isActive ? "active" : undefined}>
        <span className="player">
          {PlayerValue}
          <span className="player-symbol">{PlayerSymbol}</span>
        </span>
        <button onClick={handleOnEditClick}>{isEdit ? "Edit" : "Save"}</button>
      </li>
    </>
  );
}
